// extracted by mini-css-extract-plugin
export var brand = "_29-7";
export var compact = "_29-5";
export var extraSmall = "_29-a";
export var icon = "_29-0";
export var large = "_29-3";
export var light = "_29-1";
export var medium = "_29-4";
export var outline = "_29-9";
export var primaryDark = "_29-8";
export var primaryLight = "_29-6";
export var primaryModern = "_29-b";
export var success = "_29-2";